import { useQuery } from '@tanstack/react-query'

import type { Entity } from '@models/Entity'

import { useAuthenticatedUser } from '../../../auth/hooks/useAuthenticatedUser'
import {
  initialState,
  searchActiviteitenForEntity,
} from '../services/searchActiviteitenForEntity'

export { useSearchActiviteitenForEntity, queryKey }

const queryKey = 'search-activiteiten-for-entity'

const useSearchActiviteitenForEntity = (entity: Entity) => {
  const { hasPermissions } = useAuthenticatedUser()

  const { data } = useQuery({
    queryFn: () => searchActiviteitenForEntity({ entity }),
    queryKey: [queryKey, entity],
    enabled: hasPermissions && !!entity.id,
  })

  return {
    data: data || initialState.data,
  }
}
